
const environment = process.env.NODE_ENV || 'development';
const envSet = require(`~/api/env.${environment}.js`)
export default {
	props: ['layout','prop','glname'],
	data() {
		return {
			cdnUrl : envSet.cdnUrl,
			s3Url  : envSet.cdnUrl
		}
	}
}
